import http from "@/services/http";

export default {
    async getAllByBrandId(brandId) {
        return await http.get(`/admin/notification-lists/brand/${brandId}`);
    },

    async getNotificationListUsers(brandId) {
        return await http.get(`/admin/notification-lists/brand/${brandId}/users`);
    },

    async create(notificationList, brandId) {
        return await http.post(`/admin/notification-lists`, { ...notificationList, ...{ brand: { id: brandId } } });
    },

    async update(updatedList) {
        return await http.put(`/admin/notification-lists/${updatedList.id}`, updatedList);
    },

    async delete(notificationListId) {
        return await http.delete(`/admin/notification-lists/${notificationListId}`);
    }
};



// WEBPACK FOOTER //
// ./src/services/notificationList.js